import { AmberHoc, AmberHocProps } from '../../../util';
import {
  GetGrainBinDocument,
  GetGrainBinQuery,
  GetGrainBinQueryVariables,
  SetGrainContainerAerationScheduleMutation,
  SetGrainContainerAerationScheduleMutationVariables as Variables,
  withSetGrainContainerAerationSchedule as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';
export type WithSetGrainContainerAerationScheduleHocChildProps = {
  setGrainContainerAerationSchedule: (
    variables: Variables
  ) => Promise<SetGrainContainerAerationScheduleMutation['setGrainContainerAerationSchedule']>;
};
export const withSetGrainContainerAerationScheduleHoc: AmberHoc<
  {},
  WithSetGrainContainerAerationScheduleHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithSetGrainContainerAerationScheduleHocChildProps, typeof component>,
    WithSetGrainContainerAerationScheduleHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        setGrainContainerAerationSchedule: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: async (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
              const { setGrainContainerAerationSchedule: updated } = data;
              if (!updated) {
                return;
              }
              const cached = await proxy.readQuery<GetGrainBinQuery, GetGrainBinQueryVariables>({
                query: GetGrainBinDocument,
                variables: { grain_bin_id: variables.container_id },
              });
              if (!cached) {
                return updated;
              }
              proxy.writeQuery<GetGrainBinQuery, GetGrainBinQueryVariables>({
                query: GetGrainBinDocument,
                data: {
                  __typename: 'Query',
                  grain_bin: { ...cached.grain_bin, container: updated },
                },
                variables: { grain_bin_id: variables.container_id },
              });
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { data, errors } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.setGrainContainerAerationSchedule) {
            throw new Error('Unexpected server response');
          }
          return data.setGrainContainerAerationSchedule;
        },
      };
    },
  })(component as any);
